import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { t } from 'i18next';
import { useHandlers } from '../../../../context/page-context';
import { useDeleteShippingMethod } from '../../hooks/use-delete-shipping-method';
import type { ShippingMethodApiResponse } from '../../types/shipping-method';

export function DeleteShippingMethodModal({
  method,
  isOpen,
  closeModal,
}: {
  method: ShippingMethodApiResponse | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const deleteMethod = useDeleteShippingMethod();

  if (!method) {
    return null;
  }

  function handleDelete(method: ShippingMethodApiResponse) {
    deleteMethod.mutate(method.id, {
      onError: (error) => {
        console.error(error);
        notificationHandler.error(
          t('features:shipping_methods.common.notifications.errors.delete_failed', {
            name: method.title,
          }),
        );
      },
      onSuccess: () => {
        notificationHandler.success(
          t('features:shipping_methods.common.notifications.success.delete_succeeded', {
            name: method.title,
          }),
        );
      },
    });
  }

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={closeModal}
      onConfirm={() => {
        handleDelete(method);
        closeModal();
      }}
      loading={deleteMethod.isPending}
      title={t('features:shipping_methods.components.delete_shipping_method_modal.title')}
      confirmText={t('buttons:delete')}
      message={t('features:shipping_methods.components.delete_shipping_method_modal.body', {
        name: method.title,
      })}
    />
  );
}
